/// <amd-module name="Reporting/Visuals/VisualMessages/AccessRestrictedImage" />
import * as React from "react";
import { WrappedVisualImage } from "Reporting/Visuals/VisualMessages/WrappedVisualImage";
import { VssComponent } from "VSS/Platform/Layout";

export class AccessRestrictedImage extends VssComponent {
    public render(): JSX.Element {
        return (
            <WrappedVisualImage
                includeDependencies={["ms.vss-reporting.visual-messages-shared-data"]}
                imagePath={"ms.vss-reporting/reporting-visuals-common/images/access-restricted.png"}
            />
        );
    }
}
